export default __webpack_public_path__ + "static/media/2_Still.b35b159a.jpg";